import { Component, Inject, OnInit } from '@angular/core';
import { PlanDeMejoramientoComponent } from '../../plan-de-mejoramiento.component';
@Component({
  selector: 'app-plan-inicio',
  templateUrl: './plan-inicio.component.html',
  styleUrls: ['./plan-inicio.component.css']
})
export class PlanInicioComponent implements OnInit {

  constructor(@Inject(PlanDeMejoramientoComponent) private parent: PlanDeMejoramientoComponent) { }

  ngOnInit(): void {
  }

  public reporteVisible(item) {

    switch (item) {
      case 'inicio': {
        this.parent.menuMostrar='inicio';
        break;
      }
      case 'resumen': {
        this.parent.menuMostrar='resumen';
        break;
      }
      case 'plan-seguimiento': {
        this.parent.menuMostrar='plan-seguimiento';
        break;
      }
    }
  }
}